import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Flex, Button, Skeleton, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import styled, { keyframes } from 'styled-components'
import Balance from 'components/Balance'
import {
  usePriceBTCBusd, usePriceBnbBusd, usePriceETHBusd, usePriceETCBusd,
  usePriceLTCBusd, usePriceBVCBusd, usePriceLGCBusd, usePriceCakeBusd
} from 'state/farms/hooks'

const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
`

const StyledGrid = styled.div`
  display: grid;
  justify-items: center;
  width: 100%;
  grid-template-columns: repeat(2, minmax(100px, 1fr));
  gap: 8px; 
  
  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
    gap: 12px;
  }
`

const StyledTokenButton = styled(Button)`
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 250, 167, 0.4);
  padding: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 130px;
  height: 60px;
  animation: ${floatAnimation} 5s ease-in-out infinite;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 6px 15px rgba(0, 250, 167, 0.7);
  }

  &:active {
    transform: scale(0.95);
  }
`

const TokenText = styled(Text)`
  color: #FFD700;
  font-weight: bold;
  font-size: 15px;
`

const PriceText = styled(Text)`
  color: #00FAA7;
  font-size: 18px;
  font-weight: bold;
`

const ImageWrapper = styled.div`
  margin-right: 6px;
  width: 27px;
  height: 27px;
`

const TopTokenMovers: React.FC = () => {
  const { t } = useTranslation()
  const [visibleGroupIndex, setVisibleGroupIndex] = useState(0)

  // Kiválasztott nyolc token
  const tokenPrices = [
    { name: 'VIZSLASWAP', price: usePriceCakeBusd().toNumber(), img: '/images/wallet/2.png', link: '/swap?outputCurrency=0xadaae082237cb1772c9e079db95c117e6dd0c5af', decimals: 4 },
    { name: 'BNB', price: usePriceBnbBusd().toNumber(), img: '/images/wallet/1.png', link: '/swap?outputCurrency=0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', decimals: 0 },
    { name: 'BTC', price: usePriceBTCBusd().toNumber(), img: '/images/wallet/23.png', link: '/swap?outputCurrency=0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', decimals: 0 },
    { name: 'ETH', price: usePriceETHBusd().toNumber(), img: '/images/wallet/19.png', link: '/swap?outputCurrency=0x2170Ed0880ac9a755fd29B2688956BD959F933F8', decimals: 0 },
    { name: 'ETC', price: usePriceETCBusd().toNumber(), img: '/images/wallet/20.png', link: '/swap?outputCurrency=0x3d6545b08693daE087E957cb1180ee38B9e3c25E', decimals: 0 },
    { name: 'LTC', price: usePriceLTCBusd().toNumber(), img: '/images/wallet/18.png', link: '/swap?outputCurrency=0x4338665CBB7B2485A8855A139b75D5e34AB0DB94', decimals: 4 },
    { name: 'BVC', price: usePriceBVCBusd().toNumber(), img: '/images/wallet/7.png', link: '/swap?outputCurrency=0x2dEA12c4f08074032a9997F0a199b04aF0fC0392', decimals: 4 },
    { name: 'LGC', price: usePriceLGCBusd().toNumber(), img: '/images/wallet/6.png', link: '/swap?outputCurrency=0x3496212eC43Cc49F5151ec4405efD4975e036f89', decimals: 4 },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleGroupIndex((prevIndex) => (prevIndex + 1) % 2)
    }, 9000)

    return () => clearInterval(interval)
  }, [])

  const getTokenSubset = () => {
    const isMobile = window.innerWidth < 768
    const itemsPerPage = isMobile ? 4 : 4
    const startIndex = visibleGroupIndex * itemsPerPage
    return tokenPrices.slice(startIndex, startIndex + itemsPerPage)
  }

  return (
    <StyledContainer>
      <StyledGrid>
        {getTokenSubset().map((token) => (
          <StyledTokenButton as={Link} to={token.link} key={token.name}>
            <ImageWrapper>
              <img src={token.img} alt={token.name} width="100%" height="100%" />
            </ImageWrapper>
            <Flex flexDirection="column" alignItems="flex-start">
              <TokenText>{t(token.name)}</TokenText>
              {token.price ? (
                <PriceText>
                  <Balance bold fontSize="15px" prefix="$" decimals={token.decimals} value={token.price} />
                </PriceText>
              ) : (
                <Skeleton width={50} height={14} />
              )}
            </Flex>
          </StyledTokenButton>
        ))}
      </StyledGrid>
    </StyledContainer>
  )
}

export default TopTokenMovers
